import Link from "next/link";
import React from "react";
import { HomePageFragment } from "../../generated/graphcms";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { Button } from "../Button";
import {
  ButtonWrapper,
  HomepageComponentImage,
  HomepageComponentTitle,
  HomepageComponentVideo,
  HomepageComponentWrapper,
} from "./StyledHomepageComponent";

export interface HomePageComponentProps {
  page: HomePageFragment;
}

export const HomePageComponent: React.FC<HomePageComponentProps> = ({
  page,
}) => {
  const isDesktop = useIsDesktop();

  console.log(page);

  return (
    <HomepageComponentWrapper>
      {/* <HomepageComponentFirstImage src="/images/follow_us.gif" alt="first" /> */}
      {page.title && (
        <HomepageComponentTitle>{page.title}</HomepageComponentTitle>
      )}
      {page.displayButtons && (
        <ButtonWrapper>
          <Link href="/shop">
            <Button primary>SHOP NOW</Button>
          </Link>
          <Link href="/lookbook">
            <Button primary>LOOKBOOK</Button>
          </Link>
        </ButtonWrapper>
      )}
      {page.youtubeUrl && (
        <iframe
          style={{
            marginBottom: 40,
            width: "90vw",
            height: "calc(90vw/1.77)",
            maxWidth: 1280,
            maxHeight: 720,
          }}
          width="1280"
          height="720"
          src={page.youtubeUrl}
          frameBorder={0}
          // title="WE RAN INTO NYJAH AT COPENHAGEN OPEN"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      )}
      {page.imagesVideos.map((asset) => {
        if (!asset?.mimeType) {
          console.error("No asset or mimetype found");
          return null;
        }
        if (asset.mimeType.startsWith("video"))
          return (
            <HomepageComponentVideo
              key={asset.url}
              autoPlay={isDesktop || undefined}
              loop
              muted
              videoUrl={asset.url}
              mimeType={asset.mimeType}
            />
          );
        if (asset.mimeType.startsWith("image"))
          return (
            <HomepageComponentImage
              key={asset.url}
              src={asset.url}
              alt="homepage"
            />
          );

        return null;
      })}
    </HomepageComponentWrapper>
  );
};
